/* @flow */

import type { JSON, JSONArray } from 'common/types';

export default function items<V>(extract: JSON => V): JSONArray => Array<V> {
  return array => array.map(extract);
}
